/*
 * Silbentrennung in Produktkacheltiteln, nur wo sie gebraucht wird (Theme-Einstellung
 * `art_card_title_hyphens`, Standard aus; die Stilregel steht in snippets/art-globals.liquid).
 *
 * Horizon bricht ein Wort, das breiter ist als die Titelzeile, per `overflow-wrap: break-word`
 * mitten im Wort und ohne Strich um („Werbebanne|r“). `hyphens: auto` trennt stattdessen an einer
 * Silbengrenze mit Strich. Pauschal gesetzt trennt Safari aber auch Wörter, die in die nächste
 * Zeile passen würden („Mesh Textil-|banner“, gemessen 07.10.2026). Deshalb bekommt nur ein Titel
 * die Klasse, in dem ein Wort breiter ist als die Zeile. Die Wortbreite kommt aus einer Range über
 * das Wort, sie hängt also nicht davon ab, wie gerade umbrochen ist; die Klasse schaltet nicht hin
 * und her. Ohne Skript bleibt alles wie bei Horizon.
 */
(() => {
  const SEL = '.product-card p[role="heading"]';
  const KLASSE = 'art-hyphenate';
  const WORT = /[^\s\-‐–]+/g;
  const offen = new Set();
  let geplant = false;

  const pruefe = (p) => {
    const zeile = p.getBoundingClientRect().width;
    if (!zeile) return;
    const range = document.createRange();
    const lauf = document.createTreeWalker(p, NodeFilter.SHOW_TEXT);
    let zuBreit = false;
    for (let n = lauf.nextNode(); n && !zuBreit; n = lauf.nextNode()) {
      for (const m of n.data.matchAll(WORT)) {
        range.setStart(n, m.index);
        range.setEnd(n, m.index + m[0].length);
        let breite = 0;
        for (const r of range.getClientRects()) breite += r.width;
        if (breite > zeile + 0.5) {
          zuBreit = true;
          break;
        }
      }
    }
    p.classList.toggle(KLASSE, zuBreit);
  };

  // Gesammelt und im nächsten Frame geprüft: das Umschalten ändert die Höhe des Titels, eine
  // Prüfung direkt im ResizeObserver löste sonst eine weitere Meldung im selben Frame aus.
  const abarbeiten = () => {
    geplant = false;
    for (const p of offen) if (p.isConnected) pruefe(p);
    offen.clear();
  };
  const vormerken = (p) => {
    offen.add(p);
    if (!geplant) {
      geplant = true;
      requestAnimationFrame(abarbeiten);
    }
  };

  const ro = new ResizeObserver((eintraege) => {
    for (const e of eintraege) vormerken(e.target);
  });
  // Neue Titel sofort prüfen, nicht erst im nächsten Frame: sonst stünde der alte Umbruch einen
  // Frame lang da, und in einem Tab im Hintergrund laufen keine Frames (WebKit, gemessen).
  const beobachte = (wurzel) => {
    const titel = [...(wurzel.querySelectorAll?.(SEL) || [])];
    if (wurzel.matches?.(SEL)) titel.push(wurzel);
    for (const p of titel) {
      pruefe(p);
      ro.observe(p);
    }
  };

  beobachte(document);
  // Kacheln kommen auch später dazu (Filter, Seitenwechsel, Empfehlungen).
  new MutationObserver((liste) => {
    for (const m of liste) for (const n of m.addedNodes) if (n.nodeType === 1) beobachte(n);
  }).observe(document.body, { childList: true, subtree: true });
  // Webschriften ändern die Wortbreiten, nicht die Zeilenbreite: nach dem Laden sofort nachprüfen.
  // Nicht über den nächsten Frame, der kommt in einem Tab im Hintergrund nicht (WebKit: Titel blieb
  // mit der Breite der Ersatzschrift geprüft, gemessen 07.10.2026).
  const alle = () => document.querySelectorAll(SEL).forEach(pruefe);
  document.fonts?.ready.then(alle);
  document.fonts?.addEventListener?.('loadingdone', alle);
})();
